import { useRef } from "react";

type UseTreeProps = any;

export const useTree = (props?: UseTreeProps) => {
    const _tree = useRef<any>({
        _data: [],
        _selected: null,
    });

    const setData = (data: any) => {
        _tree.current._setData(data);
    };

    const setChildren = (parent: any, chlidren: any) => {
        _tree.current._setChildren(parent, chlidren);
    };

    const getData = () => {
        return _tree.current._data;
    };

    const getSelected = () => {
        return _tree.current._selected;
    };

    const getChecked = () => {
        let checked: any = [];
        const _ = (array: any) => {
            for (const item of array) {
                if (item.checked) {
                    checked.push(item);
                }
                if (Array.isArray(item.children)) {
                    _(item.children);
                }
            }
        };
        _(_tree.current._data);
        return checked;
    };

    const openTree = () => {
        _tree.current._openTree();
    };

    const closeTree = () => {
        _tree.current._closeTree();
    };

    const openItem = (data: any) => {
        _tree.current._openItem(data);
    };

    const closeItem = (data: any) => {
        _tree.current._closeItem(data);
    };

    return {
        tree: { _tree },
        setData,
        setChildren,
        getData,
        getSelected,
        getChecked,
        openItem,
        closeItem,
        openTree,
        closeTree,
    };
};
